import { createFileRoute } from "@tanstack/react-router";
import { apiWebhooksMetaRoute } from "@/features/meta-webhooks";

export const Route = createFileRoute("/api/webhooks/meta")({
    ...apiWebhooksMetaRoute,
});
